import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Footer from "./Footer";
import Header from "./Header";
import { Parallax } from "react-parallax";
import image2 from "../Assets/page_bg.jpg";
import { Link } from "react-router-dom";
import CrackersLoader from './CrackersLoader';
import { useNavigate } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import Sticker from "./Sticker";
import { FaHome, FaInfoCircle, FaEnvelope, FaUser, FaMapMarkerAlt, FaPhone, FaEnvelope as FaEnvelopeIcon, FaPaperPlane, FaWhatsapp, FaClock, FaMapMarkedAlt } from "react-icons/fa";
import MobileNavigation from './MobileNavigation';

function Contact() {
  const [contactData, setContactData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [formLoading, setFormLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchContactData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}content.php`);
        const { body } = response.data;
        setContactData(body.contact);
      } catch (error) {
        setError("Error fetching contact data.");
        console.error("Error fetching the contact data", error);
      } finally {
        setLoading(false);
        setIsLoading(false);
      }
    };

    fetchContactData();
  }, []);

  if (isLoading) {
    return <CrackersLoader />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormLoading(true);

    const formData = new FormData(e.target);
    
    const orderData = {
      name: formData.get('name'),
      mobile: formData.get('mobile'),
      email: formData.get('email'),
      message: formData.get('message')
    };

    try {
      const response = await axios.post(`${API_BASE_URL}send_enquiry_mail.php`, orderData);
      console.log("API Response:", response.data);
      alert("Enquiry sent successfully!");
      e.target.reset();
      navigate("/contact");
    } catch (error) {
      console.error("There was an error sending enquiry!", error);
      alert("Failed to send enquiry. Please try again.");
    } finally {
      setFormLoading(false);
    }
  };

  return (
    <div className="mathi-contact-wrapper">
      <Header />
      
      {/* Parallax Header */}
      <Parallax
        bgImage={image2}
        strength={300}
        className="about-parallax-header"
        style={{ minHeight: "100px" }}
      >
        <div className="mathi-contact-header">
          <h1 className="mathi-contact-title">
            Contact Us
          </h1>
          <nav className="mathi-contact-breadcrumb">
            <ol className="mathi-breadcrumb-list">
              <li className="mathi-breadcrumb-item">
                <Link to="/" className="mathi-breadcrumb-link">Home</Link>
              </li>
              <li className="mathi-breadcrumb-divider">
                <i className="bi bi-chevron-right"></i>
              </li>
              <li className="mathi-breadcrumb-item active">Contact Us</li>
            </ol>
          </nav>
        </div>
      </Parallax>

      {/* Contact Section */}
      <section className="mathi-contact-section">
        <div className="container" style={{display:'block'}}>
          {/* Section Header */}
          <div className="mathi-section-header text-center mb-4">
            <h2 className="mathi-section-title">
              Have Any Questions?
            </h2>
            <p className="mathi-section-description">
              We're here to help you with all your crackers needs. Reach out to us anytime!
            </p>
          </div>

          {/* Contact Info Cards */}
          <div className="row g-4 mb-4">
            {loading ? (
              <div className="text-center py-4">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : error ? (
              <div className="col-12">
                <div className="alert alert-danger text-center">{error}</div>
              </div>
            ) : (
              <>
                <div className="col-lg-4 col-md-6">
                  <div className="mathi-info-card mathi-card-address">
                    <div className="mathi-info-icon">
                      <FaMapMarkerAlt />
                    </div>
                    <div className="mathi-info-content">
                      <h3>Our Location</h3>
                      <p>{contactData?.address || "Sivakasi, Tamil Nadu"}</p>
                      <a 
                        href="https://www.google.com/maps/place/Vasuki+Traders/@9.4466887,77.7880628,17z/data=!3m1!4b1!4m6!3m5!1s0x3b06cee496ae7a5f:0xb40a259bb44059c7!8m2!3d9.4466834!4d77.7906377!16s%2Fg%2F11fylqbxj7!5m1!1e4?entry=ttu&g_ep=EgoyMDI2MDUxMy4wIKXMDSoASAFQAw%3D%3D" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="mathi-info-action"
                      >
                        <FaMapMarkedAlt className="me-1" />
                        View on Map
                      </a>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="mathi-info-card mathi-card-phone">
                    <div className="mathi-info-icon">
                      <FaPhone />
                    </div>
                    <div className="mathi-info-content">
                      <h3>Call Us</h3>
                      <p>{contactData?.phonenumber || "Contact Number"}</p>
                      <a 
                        href={`tel:${contactData?.phonenumber || ''}`}
                        className="mathi-info-action"
                      >
                        <FaWhatsapp className="me-1" />
                        Call Now
                      </a>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="mathi-info-card mathi-card-email">
                    <div className="mathi-info-icon">
                      <FaEnvelopeIcon />
                    </div>
                    <div className="mathi-info-content">
                      <h3>Email Us</h3>
                      <p>{contactData?.email || "info@mathicrackers.com"}</p>
                      <a 
                        href={`mailto:${contactData?.email || ''}`}
                        className="mathi-info-action"
                      >
                        <FaPaperPlane className="me-1" />
                        Send Email
                      </a>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          {/* Sticker */}
          <div className="mb-4">
            <Sticker />
          </div>

          {/* Map and Form Section */}
          <div className="row g-4">
            {/* Map Section */}
            <div className="col-lg-6">
              <div className="mathi-map-container">
                <h4 className="mathi-map-title">
                  <FaMapMarkerAlt className="me-2" />
                  Find Us on Map
                </h4>
                <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d62967.728667328935!2d77.76201124813679!3d9.46664571146568!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b06cee43d812d0d%3A0x8ce12e9dcdaa2a2c!2sSivakasi%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1784524705288!5m2!1sen!2sin"
                  // src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3935.71137448133!2d77.78806277400066!3d9.446688682313066!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b06cee496ae7a5f%3A0xb40a259bb44059c7!2sVasuki%20Traders!5e0!3m2!1sen!2sin!4v1779168948937!5m2!1sen!2sin"
                  frameBorder="0"
                  style={{ border: "0", width: "100%", height: "350px" }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="mathi crackers Location"
                  className="mathi-map-frame"
                />
              </div>
            </div>

            {/* Contact Form */}
            <div className="col-lg-6">
              <div className="mathi-form-container">
                <h4 className="mathi-form-title">
                  <FaEnvelope className="me-2" />
                  Send Us a Message
                </h4>
                <p className="mathi-form-subtitle mb-3">
                  Fill out the form below and we'll get back to you as soon as possible.
                </p>
                
                <form onSubmit={handleSubmit} className="mathi-contact-form">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Your Name *</label>
                        <input
                          type="text"
                          name="name"
                          className="form-control"
                          placeholder="Enter your full name"
                          required
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Mobile Number *</label>
                        <input
                          type="tel"
                          name="mobile"
                          className="form-control"
                          placeholder="Enter your mobile number"
                          required
                        />
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="mb-3">
                        <label className="form-label">Email Address *</label>
                        <input
                          type="email"
                          name="email"
                          className="form-control"
                          placeholder="Enter your email address"
                          required
                        />
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="mb-3">
                        <label className="form-label">Your Message *</label>
                        <textarea
                          name="message"
                          className="form-control"
                          rows="4"
                          placeholder="Tell us about your requirements..."
                          required
                        ></textarea>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="d-grid">
                        <button type="submit" className="btn btn-primary btn-lg" disabled={formLoading}>
                          {formLoading ? (
                            <>
                              <Spinner animation="border" size="sm" className="me-2" />
                              Sending...
                            </>
                          ) : (
                            <>
                              <FaPaperPlane className="me-2" />
                              Send Message
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          {/* WhatsApp Section */}
          <div className="mathi-whatsapp-section text-center mt-4 p-4">
            <div className="row align-items-center">
              <div className="col-md-2 text-center">
                <FaWhatsapp className="mathi-whatsapp-icon" />
              </div>
              <div className="col-md-8">
                <h5 className="mb-2">Quick WhatsApp Enquiry</h5>
                <p className="mb-3">Click below to chat directly on WhatsApp</p>
              </div>
              <div className="col-md-2">
                <a 
                  href={`https://wa.me/${contactData?.whatsapp_number || ''}?text=Hello%20Unistar%20Crackers,%20I%20have%20an%20enquiry`}
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="btn btn-success"
                >
                  <FaWhatsapp className="me-2" />
                  WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <MobileNavigation />
    </div>
  );
}

export default Contact;